/* eslint semi: 1 */

export default {
  name: 'player-setup-output',
  components: {},
  mixins: [],
  props: {
    output: {
      type: Number,
      default: () => 1
    },
    outputs: {
      type: Number,
      default: () => 1
    },
    isMultipleDisplay: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      model: {
        output: 1
      }
    };
  },
  computed: {
    outputCountOptions () {
      const options = [];
      for (let count = 1; count <= this.outputs; count++) {
        options.push({
          label: count,
          value: count,
          show: this.isMultipleDisplay && count > 1
        });
      }

      return options;
    }
  },
  watch: {
    output (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultOutputValue();
      }
    },
    isMultipleDisplay (newVal, oldVal) {
      this.setDefaultOutputValue();
    }
  },
  methods: {
    setDefaultOutputValue () {
      if (this.isMultipleDisplay && this.output < 2) {
        this.model.output = 2;
      } else {
        this.model.output = this.output;
      }

      this.$emit('change', this.model.output);
    }
  },
  mounted () {
    this.setDefaultOutputValue();
  }
};
